import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Catalogue from "./components/Catalogue";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Services from './components/Services'
function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Catalogue />
      <About />
      <Services/>
      <Contact />
      <Footer />
    </>
  );
}

export default App;
